/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import MSBar3D from './msbar3d';
import StackGroup from '../_internal/datasets/groups/cartesian.stack';
import Bar3DDataset from '../_internal/datasets/bar3d';

/**
 * Creates class StackedBar3D
 */
class StackedBar3D extends MSBar3D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'StackedBar3D';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'StackedBar3D';
  }
  /**
   * parse defualt configuration of the chart
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = '3D Stacked Bar Chart';
    config.enablemousetracking = true;
    config.maxbarheight = 50;
    config.isstacked = true;
  }

  /**
   * This method return the dataset-group definations for this charts
   * @return {Object} Multiseries bar group definition
   * @memberof StackedBar3D
   */
  getDSdef () {
    return Bar3DDataset;
  }

  /**
   * This method return the dataset-group definations for this charts
   * @return {Object}       Multiseries column group definition
   */
  getDSGroupdef () {
    return StackGroup;
  }
}
export default StackedBar3D;
